<template>
    <div class="register-container">
      <h2>Contact Us</h2>
      <form @submit.prevent="sendEmail" class="register-form">
        <div class="form-group">
          <label for="email">Email</label>
          <input
            v-model="email"
            type="email"
            id="email"
            class="input-field"
            placeholder="Enter your email"
            required
          />
        </div>
        <div class="form-group">
          <label for="question">Your Question</label>
          <textarea
            v-model="question"
            id="question"
            class="input-field"
            placeholder="Enter your question"
            rows="5"
            required
          ></textarea>
        </div>
        <button type="submit" class="submit-button">Send</button>
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
        <p v-if="successMessage" class="success-message">{{ successMessage }}</p>
      </form>
    </div>
    <FooterPublic />
  </template>
  
  <script>
  import axios from 'axios';
  import { API_BASE_URL } from '@/config';
  import FooterPublic from "@/components/FooterPublic.vue";
  
  export default {
    name: 'ContactForm',
    components: {
      FooterPublic,
    },
    data() {
      return {
        email: '',
        question: '',
        errorMessage: '',
        successMessage: '',
      };
    },
    methods: {
      async sendEmail() {
        if (!this.email || !this.question) {
          this.errorMessage = 'Please fill in all fields.';
          this.successMessage = '';
          return;
        }
  
        try {
          await axios.post(`${API_BASE_URL}/api/contact/`, {
            email: this.email,
            question: this.question,
          });
          this.successMessage = 'Your message has been sent successfully!';
          this.errorMessage = '';
          this.email = '';
          this.question = '';
        } catch (error) {
          console.error('Contact form error:', error);
          this.errorMessage = 'Failed to send your message. Please try again.';
          this.successMessage = '';
        }
      },
    },
  };
  </script>
  
  
  
  <style scoped>
  .register-container {
    max-width: 400px;
    margin: 20px auto 150px auto;
    padding: 20px;
    background-color: #192734;
    border-radius: 16px;
    color: #d9d9d9;
  }
  
  h2 {
    text-align: center;
    color: #1da1f2;
    margin-bottom: 20px;
  }
  
  .register-form {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  .form-group {
    display: flex;
    flex-direction: column;
  }
  
  label {
    color: #8899a6;
    margin-bottom: 5px;
  }
  
  .input-field {
    padding: 12px;
    background-color: #15202b;
    border: 1px solid #38444d;
    border-radius: 10px;
    color: #d9d9d9;
    font-size: 16px;
  }
  
  .input-field::placeholder {
    color: #8899a6;
  }
  
  textarea {
    resize: none;
  }
  
  .submit-button {
    padding: 12px 20px;
    background-color: #1da1f2;
    border: none;
    border-radius: 10px;
    color: #fff;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .submit-button:hover {
    background-color: #0c8ddb;
  }
  
  .error-message {
    color: #e0245e;
    text-align: center;
    margin-top: 10px;
  }
  
  .success-message {
    color: #1da1f2;
    text-align: center;
    margin-top: 10px;
  }

  @media screen and (max-width: 600px) {
    .footer {
      padding: 20px 0px 70px 0px;
    }
  }
  </style>
  